<template>
    <div class="color-input">
        <div @click="toggleColorPicker" class="color-input-output" :style="{'background-color': colors.hex, opacity: colors.a}"></div>
        <transition name="fade">
            <color-picker class="color-input-picker" :colors="colors" @input="val => {$emit('input', val)}" v-if="toggle" @click.prevent/>
        </transition>
    </div>
</template>
<script>
import ColorPicker from './ColorPicker.vue'

export default {
    props: ['colors'],
    data() {
        return {
            toggle: false,
        }
    },
	created() {
		$(document).on('click', (e) => {
			const excludes = $(this.$el).find('.color-input-output, .color-input-picker');

			if ($(e.target).closest(excludes).length === 0) {
				this.toggle = false;
			}
		});
	},
    components: {
        ColorPicker
    },
	methods: {
    	toggleColorPicker(e) {
    		this.toggle = !this.toggle;

    		if (this.toggle) {
	            setTimeout(() => {
				    const picker = $(this.$el).find('.color-input-picker');
				    const $content = $(document);
			        const is_overflow = $content.height() - 55 < picker.offset()['top'] + picker.height();
			        picker.toggleClass('color-input-picker_under', is_overflow);
			    });
		    }
	    }
	}
}
</script>

<style scoped>

.color-input-output {
    height: 24px;
    cursor: pointer;
    margin-bottom: 5px;
    border: solid 1px #ddd;
	display: inline-block;
	width: 24px;
	border-radius: 16px;
}

.color-input-picker {
    position: absolute;
    z-index: 120;
}

.color-input-picker_under {
	bottom: 100%;
	margin-bottom: 10px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active до версии 2.1.8 */

{
    opacity: 0
}

.slide-fade-enter-active {
    transition: all .8s ease;
}

.slide-fade-leave-active {
    transition: all .3s cubic-bezier(0.5, 1.0, 1.0, 0.8);
}

.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */

{
    transform: translateX(10px);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/webpack/vue/settings/components/ColorInput.vue